// TES-1990: von DefectBaseDialog konsumiert — der Dialog ist bis zum Landen von TES-1962 (#767)
// noch nicht page-wired, daher sieht die statische Analyse (fallow) die Kette als unbenutzt.
// Pragmas entfallen mit der Seiten-Verdrahtung (gleiches Muster wie DefectGroupAssignment).
// fallow-ignore-file unused-file
// fallow-ignore-file unused-export
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * useIsGroupOwner (TES-1990 / v2.3 F-RBAC-OFFB-05) — ist der User effektiver OWNER der Gruppe?
 * Fragt den Helper `is_group_owner` (Mig 369; liest group_owners_effective = statische +
 * dynamische Owner, Resolver-materialisiert Mig 364; Owner muss NICHT Mitglied sein).
 * Reines UI-Affordance-Gate — die Autorisierung erzwingt der RPC `defect_owner_assign`
 * selbst (in-body), RLS bleibt die Sicherheitsgrenze.
 */
export function useIsGroupOwner(
  groupId: string | null | undefined,
  userId: string | null | undefined,
  enabled = true,
) {
  const query = useQuery({
    queryKey: ["isGroupOwner", groupId, userId],
    queryFn: async (): Promise<boolean> => {
      /* istanbul ignore next -- defensiver Guard; `enabled` verhindert queryFn ohne ids */
      if (!groupId || !userId) return false;
      const { data, error } = await supabase.rpc("is_group_owner", {
        _user_id: userId,
        _group_id: groupId,
      });
      if (error) throw error;
      return Boolean(data);
    },
    enabled: enabled && !!groupId && !!userId,
    staleTime: 5 * 60 * 1000,
  });

  return { isOwner: query.data ?? false, isLoading: query.isLoading };
}
